import {memo} from 'react'

import {useInstallInvalidationHandler} from '../hooks/useMutate'

// Must live INSIDE SWRConfig: the handler it installs mutates that cache.
export const Invalidation = memo(function Invalidation() {
  useInstallInvalidationHandler()

  return null
})
